"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = delay;
function delay(durationMs) {
    if (durationMs <= 0) {
        return Promise.resolve();
    }
    return new Promise((resolve) => setTimeout(resolve, durationMs));
}
//# sourceMappingURL=delay.js.map